export default "__VITE_ASSET__BxH0Bd$m__"